export default {
  SET_IS_LOADING: '@loading/SET_IS_LOADING',
  SET_IS_SUCCESS: '@loading/SET_IS_SUCCESS',
  SET_IS_ERROR: '@loading/SET_IS_ERROR',
};
